import styled from "styled-components";

export const CustomStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
